/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import '../../styles/input/dropdown-select.scss';

const DropDownSelect = (props) => {
  const { label, name, value, warning, onChange, placeholder, options } = props;
  const id = `${name}-${Math.floor(Math.random() * 1000)}`;
  const dropdown = useRef();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onSelectClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onOptionClick = (option) => {
    onChange({ [name]: option });
    setIsMenuOpen(false);
  };

  const handleClick = (e) => {
    if (dropdown.current && dropdown.current.contains(e.target)) {
      return;
    }
    setIsMenuOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  return (
    <div className="warranty-select-fieldRoot">
      <label
        className={warning ? 'warning' : 'no-warning'}
        data-shrink="false"
        htmlFor={id}
        id={`${id}-label`}
      >
        {label}

      </label>
      <div className="warranty_select_wrapper" ref={dropdown}>
        <div
          className={`warranty_custom_select ${warning ? 'warning' : 'no-warning'}`}
          role="presentation"
          onClick={onSelectClick}
        >
          <p className={value ? 'selected' : ''}>{ value || placeholder }</p>
          <img src="/img/chevron-down-black.svg" alt="down arrow" data-gumlet="false" />
        </div>
        {isMenuOpen && (
        <ul className="warranty_custom_options">
          {options.map((optionItem) => (
            <li
              key={optionItem.name}
              className="custom_option"
              role="presentation"
              onClick={() => { onOptionClick(optionItem.name); }}
            >
              {optionItem.name}

            </li>
          ))}
        </ul>)}
      </div>
      {warning && (
      <p className="error">
        <img src="/img/error.svg" alt="error" />
        {' '}
        <span>{warning}</span>
      </p>)}
    </div>
  );
};
DropDownSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  warning: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};
DropDownSelect.defaultProps = {
  label: '',
  name: '',
  options: [],
  warning: '',
  placeholder: ' ',
  onChange: () => { },
  value: ''
};
export default DropDownSelect;
